export const LANDING_COPY = "Welcome to Instaswipe!";
export const UPLOAD_BUTTON = "Upload Images";
export const EXAMPLES_BUTTON = "See Examples";
